import React from 'react';
import './Legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <section className="legal-hero section-dark">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Last updated: March 1, 2025</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p>These Terms of Service ("Terms") govern your use of the Sculpit platform and services provided by Sculpit Innovations Private Limited ("Sculpit", "we", "us"), a company registered under the Companies Act, 2013, with its registered office in Bengaluru, India.</p>

            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using the Sculpit platform, you agree to be bound by these Terms. If you do not agree, please do not use our services.</p>

            <h2>2. Services</h2>
            <p>Sculpit provides:</p>
            <ul>
              <li>AI-powered 3D home design tools</li>
              <li>Real-time construction cost estimation</li>
              <li>Connection with verified construction partners</li>
              <li>Project tracking and management</li>
              <li>Escrow-protected payment processing</li>
              <li>Home loan facilitation</li>
            </ul>

            <h2>3. Account Registration</h2>
            <p>You must provide accurate, complete information when creating an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</p>

            <h2>4. Credit System</h2>
            <p>Sculpit uses a credit-based system for platform features. Credits are non-refundable once used. Unused credits from monthly plans expire at the end of each billing cycle. Free credits expire 90 days after issuance.</p>

            <h2>5. Subscription Plans</h2>
            <p>Paid subscriptions auto-renew unless cancelled. Monthly plans can be cancelled anytime. Annual plans include a 30-day refund policy. Plan features and pricing may change with 30 days' notice.</p>

            <h2>6. Construction Services</h2>
            <p>Sculpit acts as a platform connecting homeowners with verified construction partners. While we vet our partners rigorously and mandate quality inspections, the actual construction work is performed by the construction partner. Sculpit facilitates escrow payments and quality oversight.</p>

            <h2>7. Escrow Payments</h2>
            <p>Construction payments are held in escrow and released to construction partners upon milestone verification. Sculpit's escrow service is managed in partnership with regulated financial institutions. Disputes are resolved through Sculpit's dispute resolution process.</p>

            <h2>8. Intellectual Property</h2>
            <p>Designs created using Sculpit's tools belong to you. However, Sculpit retains the right to use anonymized design data to improve our AI algorithms. The Sculpit platform, including its AI models, software, and brand elements, remains our intellectual property.</p>

            <h2>9. Limitation of Liability</h2>
            <p>Sculpit shall not be liable for any indirect, incidental, or consequential damages. Our total liability shall not exceed the amount paid by you in the preceding 12 months. Construction warranties are provided by the construction partner as specified in the construction agreement.</p>

            <h2>10. Dispute Resolution</h2>
            <p>Any disputes arising out of these Terms shall be resolved through arbitration in Bengaluru, India, in accordance with the Arbitration and Conciliation Act, 1996. These Terms are governed by the laws of India.</p>

            <h2>11. Termination</h2>
            <p>We may suspend or terminate your account for violation of these Terms. You may delete your account at any time. Active construction projects will continue under the existing construction agreement.</p>

            <h2>12. Contact</h2>
            <ul>
              <li>Email: legal@sculpit.in</li>
              <li>Address: Sculpit Innovations Private Limited, No 17, 1st Floor, Bank of Baroda Building, 3rd Main Road, NGEF Layout, Postal Colony, Sanjayanagara, Bengaluru 560094, India</li>
              <li>CIN: U43900KA2026PTC217041</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
